import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardBody, CardText, Row, Col } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchJobPortalJob, resetFetchJobPortalJobError } from '../../../store/job/action';
import { DateHelper } from '@workspace/common';
import './JobInformations.scss';

export default function JobDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const { jobId } = useParams();

  // Get global state variables from redux store
  const jobRaw = useSelector((state) => state.JobPortalJobReducer.job.submissionData);
  const fetchJobError = useSelector((state) => state.JobPortalJobReducer.fetchJobError);

  // Convert submissionData to JSON
  const job = jobRaw ? JSON.parse(jobRaw) : null;


  // Fetch job details from server
  useEffect(() => {
    dispatch(fetchJobPortalJob(jobId));
  }, [jobId]);

  // Redirect to home page if error occurs while fetching job details
  useEffect(() => {
    if (fetchJobError) {
      dispatch(resetFetchJobPortalJobError());
      navigate("/job-portal/home");
    }
  }, [fetchJobError]);

  return (
    <Card className="p-0 bg-white jobappdetails-card">
      <CardHeader className="d-flex justify-content-between px-4 pb-0 bg-white border-0">
        <CardText tag="h5" className="mb-1">{job?.jobTitle}</CardText>
        <div className="d-flex align-items-center">
          <i className="las la-map-marker me-1" />
          <CardText className="color-slategray">
            {job?.country}, {job?.workLocation}
          </CardText>
        </div>
      </CardHeader>
      <CardBody className="px-4 pt-0">
        <Row className="align-items-center mx-0 mt-3 pt-3 pb-2 rounded bg-light">
          <Col className="flex-center-column" xs="4" lg="2">
            <div className="d-flex align-items-center">
              <i className="ri-briefcase-line" />
            </div>
            <small className="color-slategray">JOB ID</small>
            <h6 className="mt-1">{job?.jobId}</h6>
          </Col>
          <Col className="flex-center-column" xs="4" lg="2">
            <div className="d-flex align-items-center">
              <i className="mdi mdi-calendar-blank-outline" />
            </div>
            <small className="color-slategray">DATE POSTED</small>
            <h6 className="mt-1">{DateHelper.formatDateStandard2(job?.dateOpen)}</h6>
          </Col>
          <Col className="flex-center-column" xs="4" lg="2">
            <div className="d-flex align-items-center">
              <i className="mdi mdi-timer-outline" />
            </div>
            <small className="color-slategray">JOB EXPIRE IN</small>
            <h6 className="mt-1">{DateHelper.formatDateStandard2(job?.targetClosingDate)}</h6>
          </Col>
          <Col className="flex-center-column" xs="4" lg="2">
            <div className="d-flex align-items-center">
              <i className="mdi mdi-layers-triple-outline" />
            </div>
            <small className="color-slategray">WORK MODE</small>
            <h6 className="mt-1">{job?.workType}</h6>
          </Col>
          <Col className="flex-center-column" xs="4" lg="2">
            <div className="d-flex align-items-center">
              <i className="ri-wallet-line" />
            </div>
            <small className="color-slategray">SALARY</small>
            <h6 className="mt-1">{job?.payrate}</h6>
          </Col>
          <Col className="flex-center-column" xs="4" lg="2">
            <div className="d-flex align-items-center">
              <i className="ri-building-line" />
            </div>
            <small className="color-slategray">JOB-TYPE</small>
            <h6 className="mt-1">{job?.jobType}</h6>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}
